<template>
  <q-layout view="lHh Lpr lFf" class="auth-layout">
    <q-page-container>
      <q-page class="flex flex-center no-scroll">
        <div class="login-box animate-fade-in">
          <!-- <div class="close-row">
          <q-btn
            flat
            round
            dense
            icon="close"
            color="grey-7"
            @click="$router.push('/najava')"
          />
        </div> -->
          <!--  ЛОГО -->
          <div class="text-center q-mb-md">
            <img :src="require('@/assets/logo.png')" alt="Лого" class="logo" />
            <h6 class="text-mint text-bold q-mt-md">Најави се</h6>
          </div>

          <!--  ФОРМА -->
          <q-form @submit.prevent="najava" class="q-gutter-md q-mt-md">
            <!-- Корисничко име -->
            <q-input
              v-model="username"
              label="Корисничко име"
              outlined
              color="mint"
              dense
              clearable
              required
            >
              <template v-slot:prepend>
                <q-icon name="person" color="mint" />
              </template>
            </q-input>

            <!-- Лозинка -->
            <q-input
              v-model="pass"
              :type="showPass ? 'text' : 'password'"
              label="Лозинка"
              outlined
              color="mint"
              dense
              required
            >
              <template v-slot:prepend>
                <q-icon name="lock" color="mint" />
              </template>
              <template v-slot:append>
                <q-icon
                  :name="showPass ? 'visibility_off' : 'visibility'"
                  class="cursor-pointer text-mint"
                  @click="showPass = !showPass"
                />
              </template>
            </q-input>

            <!-- Копче -->
            <div class="text-center q-mt-md">
              <q-btn
                label="Најави се"
                type="submit"
                icon="login"
                class="btn-login"
                unelevated
                rounded
                :loading="loading"
              />
            </div>

            <!-- Грешка -->
            <div
              v-if="err"
              class="text-negative text-center text-caption q-mt-sm"
            >
              {{ err }}
            </div>
          </q-form>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
// import axios from "axios";
import api from "@/api";

export default {
  name: "NajavaKlient",
  data() {
    return {
      username: "",
      pass: "",
      showPass: false,
      err: "",
      loading: false,
    };
  },
  methods: {
    async najava() {
      this.err = "";
      this.loading = true;

      if (!this.username || !this.pass) {
        this.err = "Внесете ги сите полиња.";
        this.loading = false;
        return;
      }

      try {
        //  Повик API за клиенти (partneri)
        // const response = await axios.post(
        //   "https://nalozi.megasoft.com.mk/api/login/partneri",
        //   {
        //     username: this.username,
        //     password: this.pass,
        //   }
        // );
        const response = await api.post("/login/partneri", {
  username: this.username,
  password: this.pass,
});

        const data = response.data;
        console.log(" API Response:", data);

        //  Проверка — ако има UserName, сметаме дека е успешна најава
        if (data && data.UserName) {
          //  Креирање на објект за снимање во localStorage
          const korisnik = {
            id: data.Id,
            username: data.UserName,
            ime: data.Name,
            email: data.Email,
            uloga: "Klient",
            tip: data.UserType,
            firma: data.Name, 
            loginAt: Date.now(),
          };

          //  Сними во localStorage
          localStorage.setItem("user", JSON.stringify(korisnik));

          //  Порака за успешна најава
          this.$q.notify({
            color: "mint",
            message: ` ${korisnik.firma}`,
            icon: "login",
          });

          //  Пренасочување на клиентскиот панел
          this.$router.replace("/klient");
        } else {
          this.err = "Неуспешна најава. Проверете ги податоците.";
        }
      } catch (error) {
        console.error("API Error:", error);
        this.err =
          error.response?.data?.message ||
          "Грешка при поврзување со серверот.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/*  Глобална позадина без скрол  */
.auth-layout {
  height: 100vh;
  overflow: hidden;
  background: linear-gradient(180deg, #f2f7f7 0%, #e8f0ef 100%);
}

/*  q-page поставен да биде fullscreen  */
.no-scroll {
  height: 100vh;
  overflow: hidden;
}

/*  Централна кутија  */
.login-box {
  width: 360px;
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.08);
  padding: 40px 30px;
  text-align: center;
  transition: all 0.3s ease;
}
.login-box:hover {
  box-shadow: 0 10px 28px rgba(14, 107, 95, 0.22);
  transform: translateY(-2px);
}

/*  Лого */
.logo {
  width: 180px;
  height: auto;
  filter: drop-shadow(0 4px 8px rgba(14, 107, 95, 0.25));
}

/*  Копче */
.btn-login {
  background-color: #0e6b5f !important;
  color: white !important;
  font-weight: 600;
  font-size: 15px;
  padding: 10px 0;
  width: 80%;
  transition: all 0.25s ease;
}
.btn-login:hover {
  background-color: #0b5e54 !important;
  box-shadow: 0 4px 12px rgba(14, 107, 95, 0.3);
}

/*  Фокус на поле  */
.q-field--focused .q-field__control {
  border-color: #0e6b5f !important;
  box-shadow: 0 0 0 2px rgba(14, 107, 95, 0.1);
}

/*  Анимација при појава */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(25px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-fade-in {
  animation: fadeIn 0.8s ease-out;
}

/*  Responsive  */
@media (max-width: 600px) {
  .login-box {
    width: 90%;
    padding: 28px 22px;
  }
  .logo {
    width: 140px;
  }
  .btn-login {
    width: 100%;
  }
}
.text-mint {
  color: #0e6b5f !important;
}
.close-row {
  display: flex;
  justify-content: flex-end;
  margin-top: -10px;
  margin-right: -10px;
}
</style>
